// extracted by mini-css-extract-plugin
export default {"dmSerifFont":"StudioWorkDetailPage_dmSerifFont__G8ExH","elsieFont":"StudioWorkDetailPage_elsieFont__lb+1o"};